"use client";

import { useScroll, useTransform } from "framer-motion";
import { RefObject, useEffect, useState } from "react";

interface UseHydratedScrollOptions {
  target: RefObject<Element>;
  offset?: any; // Type from framer-motion internal
}

export function useHydratedScroll({ target, offset = ["start end", "end start"] }: UseHydratedScrollOptions) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Only use scroll when hydrated and target is available
  const { scrollYProgress } = useScroll({
    target: isMounted && target?.current ? target : null,
    offset
  });

  return {
    scrollYProgress,
    isMounted
  };
}

export function useHydratedParallax(
  scrollProgress: any,
  outputRange: [string, string] = ["-50%", "50%"],
  isMounted: boolean = true
) {
  return useTransform(
    scrollProgress,
    [0, 1],
    isMounted ? outputRange : ["0%", "0%"]
  );
}